export const TIERS = [
  { key: "none",  label: "Sem desconto", color: "#c5c1bb" },
  { key: "low",   label: "1–9%",         color: "#f59e0b" },
  { key: "mid",   label: "10–19%",       color: "#ff825d" },
  { key: "high",  label: "20%+",         color: "#2db87a" },
];

export const AVATAR_COLORS = [
  "#ff825d","#6c63ff","#2db87a","#f59e0b",
  "#3b82f6","#e879f9","#14b8a6","#f43f5e",
];

export function initials(nome) {
  if (!nome) return "?";
  return nome.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join("").toUpperCase();
}

export function avatarColor(nome) {
  if (!nome) return AVATAR_COLORS[0];
  let h = 0;
  for (let i = 0; i < nome.length; i++) h = (h * 31 + nome.charCodeAt(i)) % AVATAR_COLORS.length;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

export function discClass(v) {
  const n = Number(v);
  if (!n) return "gd-disc--none";
  if (n >= 20) return "gd-disc--high";
  if (n >= 10) return "gd-disc--mid";
  return "gd-disc--low";
}

export function fmtDisc(v) {
  return (!v && v !== 0) || v === 0 ? "—" : `${Number(v).toFixed(0)}%`;
}

export const CSS_VARS = `
  --brand:   #ff825d;
  --brand-dk:#e05a34;
  --brand-lt:#fff0ec;
  --bg:      #f7f6f4;
  --surface: #ffffff;
  --border:  #e8e5e1;
  --text:    #1a1816;
  --muted:   #8a857e;
  --ok:      #2db87a;
  --err:     #e0432a;
  --warn:    #f59e0b;
`;
